module.exports = __webpack_public_path__ + "static/img/h5-1.c324fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd116/h5-1.png
// module id = iuJf
// module chunks = 1